export * from './HandThumbLeftIcon'
